import { IAppBaiVietSelectRequest } from "../../../models/request/app-bai-viet/IAppBaiVietSelectRequest"
import { IDeleteMultipleBaseRequest } from "../../../models/request/base/deleteRequest"
import { app_baiviet } from "../../../models/response/app-phuhuynh/app_baiviet"
import { app_baiviet_vm } from "../../../models/response/app-phuhuynh/app_baiviet_vm"

export enum eBaiVietActionTypeIds {
    LOAD_START = "BAI_VIET_LOAD_START",
    LOAD_SUCCESS = "BAI_VIET_LOAD_SUCCESS",
    LOAD_ERROR = "BAI_VIET_LOAD_ERROR",

    CHANGE_SELECTED_IDS = "BAI_VIET_CHANGE_SELECTED_IDS",

    SHOW_CONFIRM = "BAI_VIET_SHOW_CONFIRM",
    CLOSE_CONFIRM = "BAI_VIET_CLOSE_CONFIRM",

    DELETE_START = "BAI_VIET_DELETE_START",
    DELETE_SUCCESS = "BAI_VIET_DELETE_SUCCESS",
    DELETE_ERROR = "BAI_VIET_DELETE_ERROR",

}

export interface IBaiVietLoadStart {
    type: eBaiVietActionTypeIds.LOAD_START,
    payload: IAppBaiVietSelectRequest
}
export interface IBaiVietLoadSuccess {
    type: eBaiVietActionTypeIds.LOAD_SUCCESS,
    payload: app_baiviet_vm[]
}
export interface IBaiVietLoadErr {
    type: eBaiVietActionTypeIds.LOAD_ERROR,
    payload: string
}

export interface IBaiVietChangeSelectedIds {
    type: eBaiVietActionTypeIds.CHANGE_SELECTED_IDS,
    payload: number[]
}
export interface IBaiVietShowConfirm {
    type: eBaiVietActionTypeIds.SHOW_CONFIRM
}
export interface IBaiVietCloseConfirm {
    type: eBaiVietActionTypeIds.CLOSE_CONFIRM
}

export interface IBaiVietDeleteStart {
    type: eBaiVietActionTypeIds.DELETE_START,
    payload: IDeleteMultipleBaseRequest
}
export interface IBaiVietDeleteSuccess {
    type: eBaiVietActionTypeIds.DELETE_SUCCESS,
}
export interface IBaiVietDeleteErr {
    type: eBaiVietActionTypeIds.DELETE_ERROR,
    payload: string
}

export type IBaiVietActionTypes = IBaiVietLoadStart | IBaiVietLoadSuccess | IBaiVietLoadErr |
    IBaiVietChangeSelectedIds |
    IBaiVietShowConfirm | IBaiVietCloseConfirm |
    IBaiVietDeleteStart | IBaiVietDeleteSuccess | IBaiVietDeleteErr